import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { Switch, styled } from "@mui/material";

export const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  paddingLeft: 4,
  paddingRight: 4,
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
};

export const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 44,
  height: 24,
  padding: 0,
  display: "flex",
  borderRadius: 16,
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(20px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "rgba(8, 109, 171, 1)",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 20,
    height: 20,
    borderRadius: 16,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

// ✅ Decode user role from JWT
export const decodeUserRole = () => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    if (!token) return "";
    const decoded = jwtDecode(token);
    return decoded.userRole || "";
  } catch {
    return "";
  }
};

// ✅ Fetch global settings
export const fetchSettings = async () => {
  let token = localStorage.getItem("token")?.replace(/^"(.*)"$/, "$1");
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/global/getAllListGlobalAppSetting`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    const fetched = {};
    response.data.allGlobalSettings.forEach((item) => {
      fetched[item.code] = item.value;
    });
    return fetched;
  } catch (error) {
    console.error("Error fetching settings:", error);
    return {};
  }
};

// ✅ Update global settings
export const updateSettings = async (settings, initialSettings) => {
  try {
    const payload = Object.entries(settings)
      .filter(([key, value]) => value !== initialSettings[key])
      .map(([code, value]) => ({ code, value }));

    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/global/updateGlobalSettingCode`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
        },
      }
    );

    return { success: response.status === 200 };
  } catch (error) {
    console.error("Error updating settings:", error);
    return { success: false };
  }
};

// ✅ Handle escape key for tooltip
export const handleEscapeKey = (e, tooltipOpen, setTooltipOpen) => {
  if (e.key === "Escape" || e.key === "Esc") {
    if (tooltipOpen) {
      setTooltipOpen(false);
      e.preventDefault();
      e.stopPropagation();
    }
  }
};
